import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';

/**
 * "Ask about this" CTA — the universal object→action handoff. Seeds the Ask
 * page with context (a doc title, search query, comparison, audit topic) so
 * any object in the app becomes a launch point into a grounded conversation.
 * AskPage reads `?seed=` and auto-runs the first turn.
 */
export function AskAboutButton({
  wsId,
  seed,
  label,
  className,
  icon = true,
}: {
  wsId: string;
  seed: string;
  label?: string;
  className?: string;
  icon?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Link
      to={`/app/workspace/${wsId}/ask?seed=${encodeURIComponent(seed)}`}
      className={
        className ??
        'inline-flex items-center gap-1.5 text-[12px] font-medium text-accent-600 hover:underline'
      }
    >
      {icon && <MessageSquare size={13} />}
      {label ?? (t('common.ask_about_this', { defaultValue: 'Ask about this' }) as string)}
    </Link>
  );
}
